<template>
  <div id="app">
    <Navbar v-on:showLogin="showModal" ref="nav" />
    <router-view v-on:showLogin="showModal" :key="componentKey" />
    <Footer v-on:showLogin="showModal" />
    <Modal ref="loginModal"></Modal>
  </div>
</template>

<script>
import Navbar from "@/views/components/Navbar";
import Korkeakoulu from "@/views/Korkeakoulu";
import Footer from "@/views/components/Footer";
import HeroStart from "@/views/components/HeroStart";
import Modal from "@/views/components/Modal";
import secretStore from "./utils/localstorage";

export default {
  data() {
    return {
      componentKey: 0,
    };
  },
  name: "app",
  components: {
    Footer,
    Navbar,
    Korkeakoulu,
    HeroStart,
    Modal,
  },
  created: function () {
    console.debug("Init the store");
    secretStore.initStore(() => {
      this.forceRerender();
    });
  },
  methods: {
    showModal() {
      this.$refs.loginModal.show();
    },
    forceRerender() {
      this.componentKey += 1;
    },
  },
};
</script>
<style lang="scss">
@import "./css/style";
</style>



// WEBPACK FOOTER //
// src/App.vue